<div [@blur]="blurState">
  <router-outlet></router-outlet>
</div>
